import instance from '../config/axios';

export const setPasswordByAdminForDoc = async (
  password: string,
  doctorId: number,
  access_token: string,
) =>
  await instance.put(
    '/api/v1/doctor/set/password/admin',
    {
      password,
      doctorId,
    },
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    },
  );
